// @see https://orval.dev/reference/configuration/output#mutator
import Axios, { AxiosError as ErrorType, AxiosRequestConfig, AxiosResponse } from "axios";
import invariant from "ts-invariant";

import { getTokenState } from "@/stores/tokenStore";

const AUTH_API_URL = import.meta.env.VITE_AUTH_API_URL as string;
invariant(AUTH_API_URL, "import.meta.env.VITE_AUTH_API_URL is not defined");

const axiosInstance = Axios.create({
  baseURL: AUTH_API_URL,
  withCredentials: false,
});

// リクエスト時に、Zustandの認証情報をヘッダーへ付与（Web/Native共通）
axiosInstance.interceptors.request.use(async (config) => {
  try {
    const { token, client, uid } = getTokenState();
    const headers = config.headers ?? {};
    if (!headers["access-token"]) {
      headers["access-token"] = token;
    }
    if (!headers["client"]) {
      headers["client"] = client;
    }
    if (!headers["uid"]) {
      headers["uid"] = uid;
    }
    config.headers = headers;
    return config;
  } catch (error) {
    console.error(error);
    return config;
  }
});

export const axios = <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  const source = Axios.CancelToken.source();
  const promise = axiosInstance({ ...config, cancelToken: source.token }).then((response) => response);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  promise.cancel = () => {
    source.cancel("Query was cancelled by React Query");
  };

  return promise;
};

export { ErrorType };
